// // /*!
// //  * React FormControl Library v3.6.0 for FormEngine
// //  * 
// //  * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
// //  * Released under the MIT license
// //  * 
// //  * 
// //  * Date: 2022-03-02T17:08Z
// //  * Copyright (c) <2022> <Xio Infotech Private Limited>
// //  * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
// //  */

// import Autocomplete from '@mui/material/Autocomplete';
// import TextField from '@mui/material/TextField';
// import React, { useState, useEffect, useRef } from 'react';
// import {
//   FormControl,
//   MenuItem,
//   FormHelperText,
//   InputLabel,
// } from '@material-ui/core';
// import ThemeControls from '../Component/AllThemesControl';
// import Selects from '@mui/material/Select';
// import { FormContext } from '../Component/Forms/FormContext';
// import elementValidate from '../Component/validation';
// import { useContext } from 'react';
// import { APIGET } from '../services/APIServices';
// import SubTable from './SubTable';
// import Dialog from '@mui/material/Dialog';
// import Button from '@mui/material/Button';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogTitle from '@mui/material/DialogTitle';
// import { MasterContext } from '../services/MasterContext';
// import { debounce } from 'lodash';
// import { FixedSizeList as List } from 'react-window';
// import OutlinedInput from '@mui/material/OutlinedInput';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import InputAdornment from '@mui/material/InputAdornment';
// import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

// export default function Select(props) {
//   const { useStyle } = ThemeControls;
//   const classes = useStyle();
//   const ref = useRef();
//   const [attr, setAttr] = React.useState();
//   const {
//     id,
//     field_type,
//     field_apipath,
//     field_history,
//     fields,
//     field_disabled_Edit,
//     field_id,
//     field_label,
//     field_placeholder,
//     field_disabled,
//     field_value,
//     field_option_src,
//     field_options,
//     field_helperText,
//     field_minlength,
//     field_maxlength,
//     field_maxvalue,
//     field_value_type,
//     field_minvalue,
//     field_error_msg_required,
//     field_error_msg_minlength,
//     field_error_msg_maxlength,
//     field_error_msg_minvalue,
//     field_error_msg_maxvalue,
//     field_error_msg_uq,
//     onChange,
//     field_mandatory,
//   } = props;
//   let { masterData } = React.useContext(MasterContext);
//   const { handleChange } = useContext(FormContext);
//   const [fieldDisable, setFieldDisable] = useState(field_disabled);
//   const [fieldOptions, setFieldOptions] = React.useState(field_options);
//   const [fieldOptions2, setFieldOptions2] = React.useState(field_options);
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [open, setOpen] = React.useState(false);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = React.useState(100);
//   const [selectedItemIndex, setSelectedItemIndex] = useState(null);
//   const [value, setValue] = React.useState('');
//   const [menuOpen, setMenuOpen] = useState(false);
//   const apiContextObj = {};

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (ref.current && !ref.current.contains(event.target)) {
//         setMenuOpen(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);

//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   if (field_apipath) {
//     apiContextObj.apiContext = field_apipath.apiContext;
//     apiContextObj.type = field_apipath.type;
//     apiContextObj.id = field_apipath.id;
//     apiContextObj.action = field_apipath.action;
//   }
//   const debouncedGetOptions = debounce(getOptions, 300);

//   async function getOptions(props) {
//     try {
//       if (props.field_option_src_context) {
//         if (
//           props.field_option_check_local_storage === 'true' &&
//           masterData[`${props.field_option_src_context}`] &&
//           masterData[`${props.field_option_src_context}`][`${field_id}`] &&
//           masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`]
//         ) {
//           setFieldOptions(
//             masterData[`${props.field_option_src_context}`] &&
//               masterData[`${props.field_option_src_context}`][`${field_id}`] &&
//               masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`]
//           );
//           setFieldOptions2(
//             masterData[`${props.field_option_src_context}`] &&
//               masterData[`${props.field_option_src_context}`][`${field_id}`] &&
//               masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`]
//           );
//         } else {
//           let APIRES = await APIGET(
//             props.field_option_src_context +
//               `/` +
//               props.field_option_src_critieria
//           ).then((APIRES) => {
//             //  
//             let responseArray = new Array();
//             let _i = 0;
//             if (props.field_select_all_label) {
//               let _obj = new Object();
//               _obj.option_label = props.field_select_all_label;
//               _obj.value = props.field_select_all_value;
//               responseArray[_i] = _obj;
//               _i++;
//             }
//             Object.keys(APIRES.data).forEach((key) => {
//               let _obj = new Object();
//               function checkType(lableData) {
//                 if (typeof lableData === 'string') {
//                   _obj.option_label = APIRES.data[key][lableData];
//                   _obj.value = APIRES.data[key][props.field_option_value];
//                 } else if (Array.isArray(lableData)) {
//                   let label = '';
//                   for (const item of lableData) {
//                     if (item.column) {
//                       label += APIRES.data[key][item.column];
//                     } else if (item.string) {
//                       label += item.string;
//                     }
//                   }
//                   _obj.option_label = label;
//                 } else {
//                    
//                 }
//               }
//               function checkValueType(valueData) {
//                 if (typeof valueData === 'string') {
//                   _obj.value = APIRES.data[key][valueData];
//                 } else if (Array.isArray(valueData)) {
//                   let value = '';
//                   for (const item of valueData) {
//                     if (item.column) {
//                       value += APIRES.data[key][item.column];
//                     } else if (item.string) {
//                       value += item.string;
//                     }
//                   }
//                   _obj.value = value;
//                 } else {
//                    
//                 }
//               }
//               checkType(props.field_option_label);
//               checkValueType(props.field_option_value);
//               responseArray[_i] = _obj;
//               _i++;
//             });
//             const sortedFieldOptions = [...responseArray].sort((a, b) => {
//               const labelA = a.option_label || ''; 
//               const labelB = b.option_label || '';
//               return labelA.localeCompare(labelB);
//             });
//             setFieldOptions(sortedFieldOptions);
//             setFieldOptions2(sortedFieldOptions);
//             if (
//               masterData[`${props.field_option_src_context}` &&
//               `${props.field_option_src_context}`]
//             ) {
//               if (masterData[`${props.field_option_src_context}`][`${field_id}`]) {
//                 masterData[`${props.field_option_src_context}`][`${field_id}`][
//                   `${props.field_option_src_critieria}`
//                 ] = sortedFieldOptions;
//               } else {
//                 masterData[`${props.field_option_src_context}`][`${field_id}`] = {};
//                 masterData[`${props.field_option_src_context}`][`${field_id}`][
//                   `${props.field_option_src_critieria}`
//                 ] = sortedFieldOptions;
//               }
//             } else {
//               masterData[`${props.field_option_src_context}`] = {};
//               masterData[`${props.field_option_src_context}`][`${field_id}`] = {};
//               masterData[`${props.field_option_src_context}`][`${field_id}`][
//                 `${props.field_option_src_critieria}`
//               ] = sortedFieldOptions;
//             }
//           });
//         }
//       }
//     } catch (err) {
//        
//     } finally {
//       setLoading(false);
//     }
//   }

//   useEffect(() => {
//     if(props.field_option_src.field_option_src_critieria){
//       debouncedGetOptions(field_option_src);
//     }
//   }, [field_option_src]);

//   useEffect(() => {
//     if (field_value !== undefined && field_value !== null) {
//       const resultObject = fieldOptions.find(option => option.value == field_value);
//       ////console.log(resultObject)
//       if (resultObject) {
//         setValue(resultObject.option_label);
//         setSelectedItemIndex(resultObject.value)
//       }
//     }
//   }, [fieldOptions]);

//   const field = {
//     field_id: field_id,
//     field_type: field_type,
//     field_disabled: field_disabled,
//     field_value: field_value,
//     field_helperText: field_helperText,
//     field_minlength: field_minlength,
//     field_maxlength: field_maxlength,
//     field_minvalue: field_minvalue,
//     field_maxvalue: field_maxvalue,
//     field_value_type: field_value_type,
//     field_mandatory: field_mandatory,
//     field_options: fieldOptions ? fieldOptions : field_options,
//     field_label: field_label,
//   };

//   function handleBlur() {
//     elementValidate(field);
//   }

//   function handleSelect(_id, event, value,index) {
//     let values = value.value;
//     setValue(value.option_label);
//     setSelectedItemIndex(values)
//     // setMenuOpen(false)
//     handleChange(field_id, {}, values);
//   }

//   const handleSearchChange = (event) => {
//     const inputValue = event.target.value.toLowerCase();
//     // handleChange(field_id, {}, inputValue);
//     setValue(event.target.value);
//     setSelectedItemIndex('')
//     if (inputValue === '') {
//       setFieldOptions(fieldOptions2); // Reset to original options
//     } else {
//       const filtered = fieldOptions2.filter((option) => 
//       (option.option_label || '').toLowerCase().includes(inputValue)
//     );
//       setFieldOptions(filtered);
//     }
//   };

//   function handleOpenMenu(){
//     setMenuOpen(true)
//     setFieldOptions(fieldOptions2)  
//   }

//   useEffect(() => {
//     if (typeof id === 'number' && field_disabled_Edit === 'yes' && field_value) {
//       setFieldDisable(true);
//     } else {
//       setFieldDisable(field_disabled);
//     }
//   }, [field_disabled]);

//   const handleClickOpen = () => {
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };

//   const Row = ({ index, style }) => {
//     // const isSelected = index === selectedItemIndex;
//     const isSelected = fieldOptions[index].value === selectedItemIndex;
//     const selectedStyles = isSelected
//     ? {
//         backgroundColor: '#e8e9ea', // Customize as needed
//         borderLeft: '3px solid #116aac'
//       }
//     : {};
//     return (
//       <>
//       <MenuItem  style={{ ...style, ...selectedStyles }} onClick={() => handleSelect({},{}, fieldOptions[index],index)}>
//         <span>{fieldOptions[index].option_label}</span>
//       </MenuItem >
//       </>
//     )
//   };
//   let height =''
//   if(fieldOptions.length<6){
//     height= fieldOptions.length * 33;
//   }else{
//     height= 6 * 33;
//   }

//   return (
//     <div className={classes.inputroot}>
//       <div style={{ display: 'flex' }}>
//         <InputLabel className={classes.label}>{field_label}</InputLabel>
//         {field_mandatory === 'yes' ? (
//           <span
//             style={{
//               fontSize: '18px',
//               color: '#d71729',
//               fontWeight: '400',
//               lineHeight: '20px',
//               transform: 'translateY(-2px)',
//             }}
//           >
//             *
//           </span>
//         ) : null}
//       </div>

//         {/* <TextField
//           // className={classes.searchSelect}
//           placeholder="Search..."
//          value={value}
//           onChange={handleSearchChange}
//         /> */}
//          <TextField className={classes.input}
//           id = {field_id}
//           placeholder="Search..."
//           disabled={fieldDisable}
//           value={value}
//           onChange={handleSearchChange}
//           // onKeyDown={handleKeyDown}
//           onBlur={handleBlur}
//           onClick={handleOpenMenu}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position='end'>
//                 {menuOpen?<ArrowDropUpIcon />:<ArrowDropDownIcon />}
//               </InputAdornment>
//             ),
//           }}
//         />
//         {menuOpen&&<div className={classes.ListBox}  ref={ref}>
//             {loading ? (
//             <MenuItem><span>Loading...</span></MenuItem>
//           ) :fieldOptions.length === 0?<MenuItem><span>No search result found.</span></MenuItem>
//           :(
//             <List height={height} itemCount={fieldOptions.length} itemSize={33}>
//               {Row}
//             </List>
//            )}
//       </div>
//       }
//       {field_history === 'yes' && (
//           <button className="hbtn" onClick={handleClickOpen}>
//             History
//           </button>
//         )}
//       <FormHelperText>{field_helperText}</FormHelperText>

//       {fields && (
//         <Dialog maxWidth="md" open={open} onClose={handleClose}>
//           <DialogTitle>{fields.heading}</DialogTitle>
//           <DialogContent>
//             <SubTable fieldsData={fields.columns} apiPath={field_apipath} apiContextObj={apiContextObj} id={id} />
//             <DialogActions>
//               <Button onClick={handleClose}>Close</Button>
//             </DialogActions>
//           </DialogContent>
//         </Dialog>
//       )}
//     </div>
//   );
// }

// /*!
//  * React FormControl Library v3.6.0 for FormEngine
//  * 
//  * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
//  * Released under the MIT license
//  * 
//  * 
//  * Date: 2022-03-02T17:08Z
//  * Copyright (c) <2022> <Xio Infotech Private Limited>
//  * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
//  */

// import Autocomplete from '@mui/material/Autocomplete';
// import TextField from '@mui/material/TextField';
// import React, { useState, useEffect, useRef } from 'react';
// import {
//   FormControl,
//   MenuItem,
//   FormHelperText,
//   InputLabel,
// } from '@material-ui/core';
// import ThemeControls from '../Component/AllThemesControl';
// import Selects from '@mui/material/Select';
// import { FormContext } from '../Component/Forms/FormContext';
// import elementValidate from '../Component/validation';
// import { useContext } from 'react';
// import { APIGET } from '../services/APIServices';
// import SubTable from './SubTable';
// import Dialog from '@mui/material/Dialog';
// import Button from '@mui/material/Button';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogTitle from '@mui/material/DialogTitle';
// import { MasterContext } from '../services/MasterContext';
// import { debounce } from 'lodash';
// import { FixedSizeList as List } from 'react-window';
// import OutlinedInput from '@mui/material/OutlinedInput';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import InputAdornment from '@mui/material/InputAdornment';
// import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

// export default function Select(props) {
//   const { useStyle } = ThemeControls;
//   const classes = useStyle();
//   const ref = useRef();
//   const [attr, setAttr] = React.useState();
//   const {
//     id,
//     field_type,
//     field_apipath,
//     field_history,
//     fields,
//     field_disabled_Edit,
//     field_id,
//     field_label,
//     field_placeholder,
//     field_disabled,
//     field_value,
//     field_option_src,
//     field_options,
//     field_helperText,
//     field_minlength,
//     field_maxlength,
//     field_maxvalue,
//     field_value_type,
//     field_minvalue,
//     field_error_msg_required,
//     field_error_msg_minlength,
//     field_error_msg_maxlength,
//     field_error_msg_minvalue,
//     field_error_msg_maxvalue,
//     field_error_msg_uq,
//     onChange,
//     field_mandatory,
//   } = props;
//   let { masterData } = React.useContext(MasterContext);
//   const { handleChange } = useContext(FormContext);
//   const [fieldDisable, setFieldDisable] = useState(field_disabled);
//   const [fieldOptions, setFieldOptions] = React.useState(field_options);
//   const [fieldOptions2, setFieldOptions2] = React.useState(field_options);
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [open, setOpen] = React.useState(false);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = React.useState(100);
//   const [selectedItemIndex, setSelectedItemIndex] = useState(null);
//   const [value, setValue] = React.useState('');
//   const [menuOpen, setMenuOpen] = useState(false);
//   const apiContextObj = {};

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (ref.current && !ref.current.contains(event.target)) {
//         setMenuOpen(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);

//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   if (field_apipath) {
//     apiContextObj.apiContext = field_apipath.apiContext;
//     apiContextObj.type = field_apipath.type;
//     apiContextObj.id = field_apipath.id;
//     apiContextObj.action = field_apipath.action;
//   }
//   const debouncedGetOptions = debounce(getOptions, 300);

//   async function getOptions(props) {
//     try {
//       if (props.field_option_src_context) {
//         if (
//           props.field_option_check_local_storage === 'true' &&
//           masterData[`${props.field_option_src_context}`] &&
//           masterData[`${props.field_option_src_context}`][`${field_id}`] &&
//           masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`]
//         ) {
//           setFieldOptions(
//             masterData[`${props.field_option_src_context}`] &&
//             masterData[`${props.field_option_src_context}`][`${field_id}`] &&
//             masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`]
//           );
//           setFieldOptions2(
//             masterData[`${props.field_option_src_context}`] &&
//             masterData[`${props.field_option_src_context}`][`${field_id}`] &&
//             masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`]
//           );
//         } else {
//           let APIRES = await APIGET(
//             props.field_option_src_context +
//             `/` +
//             props.field_option_src_critieria
//           ).then((APIRES) => {
//             //  
//             let responseArray = new Array();
//             let _i = 0;
//             if (props.field_select_all_label) {
//               let _obj = new Object();
//               _obj.option_label = props.field_select_all_label;
//               _obj.value = props.field_select_all_value;
//               responseArray[_i] = _obj;
//               _i++;
//             }
//             Object.keys(APIRES.data).forEach((key) => {
//               let _obj = new Object();
//               function checkType(lableData) {
//                 if (typeof lableData === 'string') {
//                   _obj.option_label = APIRES.data[key][lableData];
//                   _obj.value = APIRES.data[key][props.field_option_value];
//                 } else if (Array.isArray(lableData)) {
//                   let label = '';
//                   for (const item of lableData) {
//                     if (item.column) {
//                       label += APIRES.data[key][item.column];
//                     } else if (item.string) {
//                       label += item.string;
//                     }
//                   }
//                   _obj.option_label = label;
//                 } else {
//                    
//                 }
//               }
//               function checkValueType(valueData) {
//                 if (typeof valueData === 'string') {
//                   _obj.value = APIRES.data[key][valueData];
//                 } else if (Array.isArray(valueData)) {
//                   let value = '';
//                   for (const item of valueData) {
//                     if (item.column) {
//                       value += APIRES.data[key][item.column];
//                     } else if (item.string) {
//                       value += item.string;
//                     }
//                   }
//                   _obj.value = value;
//                 } else {
//                    
//                 }
//               }
//               checkType(props.field_option_label);
//               checkValueType(props.field_option_value);
//               responseArray[_i] = _obj;
//               _i++;
//             });
//             const sortedFieldOptions = [...responseArray].sort((a, b) => {
//               const labelA = a.option_label || '';
//               const labelB = b.option_label || '';
//               return labelA.localeCompare(labelB);
//             });
//             setFieldOptions(sortedFieldOptions);
//             setFieldOptions2(sortedFieldOptions);
//             if (
//               masterData[`${props.field_option_src_context}` &&
//               `${props.field_option_src_context}`]
//             ) {
//               if (masterData[`${props.field_option_src_context}`][`${field_id}`]) {
//                 masterData[`${props.field_option_src_context}`][`${field_id}`][
//                   `${props.field_option_src_critieria}`
//                 ] = sortedFieldOptions;
//               } else {
//                 masterData[`${props.field_option_src_context}`][`${field_id}`] = {};
//                 masterData[`${props.field_option_src_context}`][`${field_id}`][
//                   `${props.field_option_src_critieria}`
//                 ] = sortedFieldOptions;
//               }
//             } else {
//               masterData[`${props.field_option_src_context}`] = {};
//               masterData[`${props.field_option_src_context}`][`${field_id}`] = {};
//               masterData[`${props.field_option_src_context}`][`${field_id}`][
//                 `${props.field_option_src_critieria}`
//               ] = sortedFieldOptions;
//             }
//           });
//         }
//       }
//     } catch (err) {
//        
//     } finally {
//       setLoading(false);
//     }
//   }

//   useEffect(() => {
//     if (props.field_option_src.field_option_src_critieria) {
//       debouncedGetOptions(field_option_src);
//     }
//   }, [field_option_src]);

//   useEffect(() => {
//     if (field_value !== undefined && field_value !== null) {
//       const resultObject = fieldOptions.find(option => option.value == field_value);
//       ////console.log(resultObject)
//       if (resultObject) {
//         setValue(resultObject.option_label);
//         setSelectedItemIndex(resultObject.value)
//       }
//     }
//   }, [fieldOptions]);

//   const field = {
//     field_id: field_id,
//     field_type: field_type,
//     field_disabled: field_disabled,
//     field_value: field_value,
//     field_helperText: field_helperText,
//     field_minlength: field_minlength,
//     field_maxlength: field_maxlength,
//     field_minvalue: field_minvalue,
//     field_maxvalue: field_maxvalue,
//     field_value_type: field_value_type,
//     field_mandatory: field_mandatory,
//     field_options: fieldOptions ? fieldOptions : field_options,
//     field_label: field_label,
//   };

//   function handleBlur() {
//     elementValidate(field);
//   }

//   function handleSelect(_id, event, value, index) {
//     if (value && value.value) {
//       let values = value.value;
//       setValue(value.option_label);
//       setSelectedItemIndex(values);
//       handleChange(field_id, {}, values);
//     }
//   }

// const handleSearchChange = (event) => {
//   const inputValue = event.target.value.toLowerCase();
//   const filteredOptions = fieldOptions2.filter((option) => 
//     option.option_label.toLowerCase().includes(inputValue)
//   );
//   setFieldOptions(inputValue === '' ? fieldOptions2 : filteredOptions);
//   setValue(event.target.value);
//   setSelectedItemIndex('');
// };

//   function handleOpenMenu() {
//     setFieldOptions(fieldOptions2)
//   }

//   useEffect(() => {
//     if (typeof id === 'number' && field_disabled_Edit === 'yes' && field_value) {
//       setFieldDisable(true);
//     } else {
//       setFieldDisable(field_disabled);
//     }
//   }, [field_disabled]);

//   const handleClickOpen = () => {
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };

//   return (
//     <div className={classes.inputroot}>
//       <div style={{ display: 'flex' }}>
//         <InputLabel className={classes.label}>{field_label}</InputLabel>
//         {field_mandatory === 'yes' ? (
//           <span
//             style={{
//               fontSize: '18px',
//               color: '#d71729',
//               fontWeight: '400',
//               lineHeight: '20px',
//               transform: 'translateY(-2px)',
//             }}
//           >
//             *
//           </span>
//         ) : null}
//       </div>


//       {/* <TextField className={classes.input}
//           id = {field_id}
//           placeholder="Search..."
//           disabled={fieldDisable}
//           value={value}
//           onChange={handleSearchChange}
//           // onKeyDown={handleKeyDown}
//           onBlur={handleBlur}
//           onClick={handleOpenMenu}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position='end'>
//                 {menuOpen?<ArrowDropUpIcon />:<ArrowDropDownIcon />}
//               </InputAdornment>
//             ),
//           }}
//         /> */}
//         <Autocomplete
//           disablePortal
//           clearOnEscape
//           className={classes.autocomplete}
//           id={field_id}
//           options={fieldOptions}
//           value={fieldOptions.find(option => option.value === selectedItemIndex) || null}
//           getOptionLabel={(option) => option.option_label}
//           onChange={(event, value) => handleSelect({}, event, value)}
//           inputValue={value}
//           disabled={fieldDisable}
//           onClick={handleOpenMenu}
//           onInputChange={(event, newInputValue) => handleSearchChange({ target: { value: newInputValue } })}
//           placeholder="Search..."
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               onBlur={handleBlur}
//             />
//           )}
//         />


//       {/* {menuOpen&&<div className={classes.ListBox}  ref={ref}>
//             {loading ? (
//             <MenuItem><span>Loading...</span></MenuItem>
//           ) :fieldOptions.length === 0?<MenuItem><span>No search result found.</span></MenuItem>
//           :(
//             <List height={height} itemCount={fieldOptions.length} itemSize={33}>
//               {Row}
//             </List>
//            )}
//       </div>
//       } */}
//       {field_history === 'yes' && (
//         <button className="hbtn" onClick={handleClickOpen}>
//           History
//         </button>
//       )}
//       <FormHelperText>{field_helperText}</FormHelperText>

//       {fields && (
//         <Dialog maxWidth="md" open={open} onClose={handleClose}>
//           <DialogTitle>{fields.heading}</DialogTitle>
//           <DialogContent>
//             <SubTable fieldsData={fields.columns} apiPath={field_apipath} apiContextObj={apiContextObj} id={id} />
//             <DialogActions>
//               <Button onClick={handleClose}>Close</Button>
//             </DialogActions>
//           </DialogContent>
//         </Dialog>
//       )}
//     </div>
//   );
// }



import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import React, { useState, useEffect, useRef } from 'react';
import {
  FormControl,
  MenuItem,
  FormHelperText,
  InputLabel,
} from '@material-ui/core';
import ThemeControls from '../Component/AllThemesControl';
import Selects from '@mui/material/Select';
import { FormContext } from '../Component/Forms/FormContext';
import elementValidate from '../Component/validation';
import { useContext } from 'react';
import { APIGET } from '../services/APIServices';
import SubTable from './SubTable';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { MasterContext } from '../services/MasterContext';
import { debounce } from 'lodash';
import { FixedSizeList as List } from 'react-window';
import OutlinedInput from '@mui/material/OutlinedInput';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import InputAdornment from '@mui/material/InputAdornment';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

export default function Select(props) {
  const { useStyle } = ThemeControls;
  const classes = useStyle();
  const ref = useRef();
  const [attr, setAttr] = React.useState();
  const {
    id,
    field_type,
    field_apipath,
    field_history,
    fields,
    field_disabled_Edit,
    field_id,
    field_label,
    field_placeholder,
    field_disabled,
    field_value,
    field_option_src,
    field_options,
    field_helperText,
    field_minlength,
    field_maxlength,
    field_maxvalue,
    field_value_type,
    field_minvalue,
    field_error_msg_required,
    field_error_msg_minlength,
    field_error_msg_maxlength,
    field_error_msg_minvalue,
    field_error_msg_maxvalue,
    field_error_msg_uq,
    onChange,
    field_mandatory,
  } = props;
  let { masterData } = React.useContext(MasterContext);
  const { handleChange } = useContext(FormContext);
  const [fieldDisable, setFieldDisable] = useState(field_disabled);
  const [fieldOptions, setFieldOptions] = React.useState(field_options||[]);
  const [fieldOptions2, setFieldOptions2] = React.useState(field_options||[]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = React.useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [selectedItemIndex, setSelectedItemIndex] = useState(null);
  const [value, setValue] = React.useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const apiContextObj = {};

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  if (field_apipath) {
    apiContextObj.apiContext = field_apipath.apiContext;
    apiContextObj.type = field_apipath.type;
    apiContextObj.id = field_apipath.id;
    apiContextObj.action = field_apipath.action;
  }
  const debouncedGetOptions = debounce(getOptions, 300);

  async function getOptions(props) {
    try {
      if (props.field_option_src_context) {
        if (
          props.field_option_check_local_storage === 'true' &&
          masterData[`${props.field_option_src_context}`] &&
          masterData[`${props.field_option_src_context}`][`${props.field_option_src_critieria}`]
        ) {
          setFieldOptions(
            masterData[`${props.field_option_src_context}`] &&
            masterData[`${props.field_option_src_context}`][`${props.field_option_src_critieria}`]
          );
          setFieldOptions2(
            masterData[`${props.field_option_src_context}`] &&
            masterData[`${props.field_option_src_context}`][`${props.field_option_src_critieria}`]
          );
        } else {
          let APIRES = await APIGET(
            props.field_option_src_context +
            `/` +
            props.field_option_src_critieria
          ).then((APIRES) => {
            //  
            let responseArray = new Array();
            let _i = 0;
            if (props.field_select_all_label) {
              let _obj = new Object();
              _obj.option_label = props.field_select_all_label;
              _obj.value = props.field_select_all_value;
              responseArray[_i] = _obj;
              _i++;
            }
            if(APIRES.data&&APIRES.data.length>0){
            Object.keys(APIRES.data).forEach((key) => {
              let _obj = new Object();
              function checkType(lableData) {
                if (typeof lableData === 'string') {
                  _obj.option_label = APIRES.data[key][lableData];
                  _obj.value = APIRES.data[key][props.field_option_value];
                } else if (Array.isArray(lableData)) {
                  let label = '';
                  for (const item of lableData) {
                    if (item.column) {
                      label += APIRES.data[key][item.column];
                    } else if (item.string) {
                      label += item.string;
                    }
                  }
                  _obj.option_label = label;
                } else {
                   
                }
              }
              function checkValueType(valueData) {
                if (typeof valueData === 'string') {
                  _obj.value = APIRES.data[key][valueData];
                } else if (Array.isArray(valueData)) {
                  let value = '';
                  for (const item of valueData) {
                    if (item.column) {
                      value += APIRES.data[key][item.column];
                    } else if (item.string) {
                      value += item.string;
                    }
                  }
                  _obj.value = value;
                } else {
                   
                }
              }
              checkType(props.field_option_label);
              checkValueType(props.field_option_value);
              responseArray[_i] = _obj;
              _i++;
            });
            const sortedFieldOptions = [...responseArray].sort((a, b) => {
              const labelA = a.option_label || '';
              const labelB = b.option_label || '';
              return labelA.localeCompare(labelB);
            });
            // const sortedFieldOptions = [...responseArray].sort((a, b) => {
            //   const labelA = a.option_label || '';
            //   const labelB = b.option_label || '';
            //   const labelAContainsAll = labelA.includes('All');
            //   const labelBContainsAll = labelB.includes('All');
            
            //   if (labelAContainsAll && !labelBContainsAll) {
            //     return -1; // Move labelA containing "All" to the top
            //   } else if (!labelAContainsAll && labelBContainsAll) {
            //     return 1; // Move labelB containing "All" to the top
            //   } else {
            //     return labelA.localeCompare(labelB); // Sort alphabetically
            //   }
            // });

            const Options = sortedFieldOptions.map(item => ({
              option_label: item.option_label === ""||item.option_label === " " ? "Empty" : item.option_label,
              value: item.value === "" ? " " : item.value
          }));
            
            setFieldOptions(Options);
            setFieldOptions2(Options);
              if (masterData[`${props.field_option_src_context}`]) {
                masterData[`${props.field_option_src_context}`][`${props.field_option_src_critieria}`] = Options;
              } else {
                masterData[`${props.field_option_src_context}`] = {};
                masterData[`${props.field_option_src_context}`][`${props.field_option_src_critieria}`] = Options;
              }
            }else{
                const responseArray = [
                  {
                    "option_label": "Data Not Found",
                    "value": "0"
                  }
                ];
  
                setFieldOptions(responseArray);
            }
          });
        }
      }
    } catch (err) {
       
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (props.field_option_src.field_option_src_critieria) {
      debouncedGetOptions(field_option_src);
    }
  }, [props.field_option_src.field_option_src_critieria]);

  useEffect(() => {
    if (field_value !== undefined && field_value !== null &&field_value) {
      const resultObject = fieldOptions.find(option => option.value == field_value);
      ////console.log(resultObject)
      if (resultObject) {
        setValue(resultObject.option_label);
        setSelectedItemIndex(resultObject.value)
      }
    }else{
      setValue('');
      setSelectedItemIndex(null)
      // console.log('test')
    }
  }, [fieldOptions, field_value]);
// console.log(field_value)
  const field = {
    field_id: field_id,
    field_type: field_type,
    field_disabled: field_disabled,
    field_value: field_value,
    field_helperText: field_helperText,
    field_minlength: field_minlength,
    field_maxlength: field_maxlength,
    field_minvalue: field_minvalue,
    field_maxvalue: field_maxvalue,
    field_value_type: field_value_type,
    field_error_msg_required: field_error_msg_required,
    field_mandatory: field_mandatory,
    field_options: fieldOptions ? fieldOptions : field_options,
    field_label: field_label,
  };

  function handleBlur() {
    elementValidate(field);
  }

  function handleSelect(_id, event, value, index) {
    if (value && value.value) {
      let values = value.value;
      setValue(value.option_label);
      setSelectedItemIndex(values);
      handleChange(field_id, {}, values);
    }else {
      // Value is null, pass null to handleChange
      setValue(''); // Clear the input value
      setSelectedItemIndex('');
      handleChange(field_id, {}, '');
    }
  }

const handleSearchChange = (event) => {
  const inputValue = event.target.value.toLowerCase();
  const filteredOptions = fieldOptions2.filter((option) => 
    option.option_label.toLowerCase().includes(inputValue)
  );
  setFieldOptions(inputValue === '' ? fieldOptions2 : filteredOptions);
  setValue(event.target.value);
  setSelectedItemIndex('');
};

  function handleOpenMenu() {
    setFieldOptions(fieldOptions2)
  }

  useEffect(() => {
    if (typeof id === 'number' && field_disabled_Edit === 'yes' && field_value) {
      setFieldDisable(true);
    } else {
      setFieldDisable(field_disabled);
    }
  }, [field_disabled]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.inputroot}>
      <div style={{ display: 'flex' }}>
        <InputLabel className={classes.label}>{field_label}</InputLabel>
        {field_mandatory === 'yes' ? (
          <span
            style={{
              fontSize: '18px',
              color: '#d71729',
              fontWeight: '400',
              lineHeight: '20px',
              transform: 'translateY(-2px)',
            }}
          >
            *
          </span>
        ) : null}
      </div>


      {/* <TextField className={classes.input}
          id = {field_id}
          placeholder="Search..."
          disabled={fieldDisable}
          value={value}
          onChange={handleSearchChange}
          // onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          onClick={handleOpenMenu}
          InputProps={{
            startAdornment: (
              <InputAdornment position='end'>
                {menuOpen?<ArrowDropUpIcon />:<ArrowDropDownIcon />}
              </InputAdornment>
            ),
          }}
        /> */}
       <Autocomplete
          disablePortal
          // clearOnEscape
          disableClearable
          className={classes.autocomplete}
          id={field_id}
          options={fieldOptions}
          value={fieldOptions.find((option) => option.value === selectedItemIndex) || null}
          getOptionLabel={(option) => option.option_label}
          getOptionDisabled={(option) => (option.option_label==='Loading...' || option.option_label==='Data Not Found')?true:false}
          onChange={(event, value) => handleSelect({}, event, value)}
          inputValue={value}
          disabled={fieldDisable}
          onInputChange={(event, newInputValue) => {setValue(newInputValue); 
            if (newInputValue === "") {
              handleChange(field_id, {}, '');
              setValue('');
              setSelectedItemIndex('');
          }}}
          // open='true'
          renderInput={(params) => (
            <TextField
              {...params}
              onBlur={handleBlur}
              placeholder="Search..."
            />
          )}
        />
      {field_history === 'yes' && (
        <button className="hbtn" onClick={handleClickOpen}>
          History
        </button>
      )}
      <FormHelperText>{field_helperText}</FormHelperText>

      {fields && (
        <Dialog maxWidth="md" open={open} onClose={handleClose}>
          <DialogTitle>{fields.heading}</DialogTitle>
          <DialogContent>
            <SubTable fieldsData={fields.columns} apiPath={field_apipath} apiContextObj={apiContextObj} id={id} />
            <DialogActions>
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
